import React, {useEffect, useState} from 'react'
import httpRequest from '../components/request-api'
import Chip from '@material-ui/core/Chip'
import ReactApexChart from 'react-apexcharts'
import PickerDialog from '../components/PickerDialog'
import {withRouter} from 'react-router'
import moment from 'moment'
import {withNamespaces} from 'react-i18next'
import '../assets/handicap.scss'
import _ from 'lodash'

function Handicap(props) {
    const t = props.t
    const memberCode = props.match.params.id
    const today = new Date()
    const lastYear = new Date()
    lastYear.setFullYear(lastYear.getFullYear() - 1)

    const [chartData, setChartData] = useState([])
    const [select, setSelect] = useState({
        min: lastYear.getTime(),
        max: today.getTime(),
    })
    const [dialogData, setDialogData] = useState({
        open: false,
        type: 'year',
        views: [],
        value: new Date().getFullYear(),
    })

    const chartOptions = {
        chart: {
            id: 'mainChart',
            height: 350,
            type: 'line',
            toolbar: {
                autoSelected: 'pan',
                show: false
            },
        },
        tooltip: {
            x: {
                formatter: (value) => {
                    return moment(value).format('DD MMMM yyyy')
                },
            },
            y: {
                formatter: (value) => {
                    if (value < 0) {
                        value = `+${Math.abs(value)}`
                    }

                    return value
                }
            }
        },
        stroke: {
            width: 7,
            curve: 'straight',
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                gradientToColors: [ '#FDD835'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
            },
        },
        markers: {
            size: 4,
            colors: ["#FFA41B"],
            strokeColors: "#fff",
            strokeWidth: 2,
            hover: {
                size: 7,
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                formatter: (value) => {
                    return moment(value).format('DD MMM YY')
                }
            }
        },
        yaxis: {
            tickAmount: 10,
            labels: {
                formatter: (value) => {
                    if (value < 0) {
                        value = `+${Math.abs(value).toFixed(1)}`
                    } else {
                        value = value.toFixed(1)
                    }

                    return value
                }
            }
        },
        optionsLine: {
            chart: {
                id: 'selectChart',
                height: 130,
                type: 'area',
                brush:{
                    target: 'mainChart',
                    enabled: true
                },
                selection: {
                    enabled: true,
                    xaxis: select
                },
            },
            colors: ['#008FFB'],
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.91,
                    opacityTo: 0.1,
                }
            },
            xaxis: {
                type: 'datetime',
                tooltip: {
                    enabled: false
                }
            },
            yaxis: {
                tickAmount: 2,
                labels: {
                    formatter: (value) => {
                        if (value < 0) {
                            value = `+${Math.abs(value).toFixed(1)}`
                        } else {
                            value = value.toFixed(1)
                        }

                        return value
                    }
                }
            }
        }
    }

    function getData() {
        httpRequest.historyYear(memberCode).then((result) => {
            const handicapData = result.data.result.data

            setChartData([{
                name: t('handicapIndex'),
                data: handicapData.map((handicap) => ({
                    x: new Date(handicap['calculate_date']).getTime(),
                    y: handicap['handicap_index']
                })),
            }])

            if (handicapData.length) {
                const max = new Date(handicapData[0]['calculate_date'])
                const min = new Date(handicapData[0]['calculate_date'])
                min.setFullYear(min.getFullYear() - 1)

                setSelect({
                    min: min.getTime(),
                    max: max.getTime(),
                })
            }
        })
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <React.Fragment>
            {
                chartData.length === 0
                    ? <p>{t('loading')}</p>
                    : chartData[0]['data'].length === 0 || chartData[0]['data'].map((data) => data['y']).every(_.isNull)
                    ? <div style={{height: "50vh"}}>
                        <div className="d-flex flex-column align-items-center justify-content-center" style={{height: "100%"}}>
                            <div>
                                <img src='/assets/img/handicap/no-score.svg' alt='no handicap score' />
                                <h6 className="mt-2" style={{color: "#929BA2"}}>{t('noScoreHistoryAlt')}</h6>
                            </div>
                        </div>
                      </div>
                    // replace this with a no data component
                    : <React.Fragment>
                        <div className="d-flex justify-content-end">
                            <Chip
                                label={`1 ${t('month')}`}
                                color="primary"
                                variant={dialogData.type === 'month' ? 'default': 'outlined'}
                                onClick={() => setDialogData({
                                    open: true,
                                    type: 'month',
                                    views: ['year', 'month'],
                                    value: dialogData.value,
                                })}
                            />
                            <Chip
                                label={`1 ${t('year')}`}
                                color="primary"
                                variant={dialogData.type === 'year' ? 'default': 'outlined'}
                                onClick={() => setDialogData({
                                    open: true,
                                    type: 'year',
                                    views: ['year'],
                                    value: dialogData.value,
                                })}
                            />
                            <Chip
                                label={t('all')}
                                color="primary"
                                variant={dialogData.type === 'all' ? 'default': 'outlined'}
                                onClick={() => {
                                    setDialogData({
                                        open: false,
                                        type: 'all',
                                        views: dialogData.views,
                                        value: dialogData.value,
                                    })
                                    setSelect({
                                        min: undefined,
                                        max: undefined
                                    })
                                }}
                            />
                        </div>
                        <div>
                            <ReactApexChart options={chartOptions} series={chartData} type="line" height={350} />
                            <ReactApexChart options={chartOptions.optionsLine} series={chartData} type="area" height={130} />
                        </div>
                    </React.Fragment>
            }
            <PickerDialog dialogData={dialogData} onClose={(value) => {
                const data = {
                    open: false,
                    type: dialogData.type,
                    views: [],
                    value: dialogData.value,
                }

                if (moment.isMoment(value)) {
                    if (dialogData.type === 'year') {
                        const year = parseInt(value.format('yyyy'))
                        const min = new Date(`${year}-01-01`)
                        const max = new Date(`${year+1}-01-01`)

                        data['value'] = year

                        setSelect({
                            min: min.getTime(),
                            max: max.getTime(),
                        })

                    } else if (dialogData.type === 'month') {
                        const year = parseInt(value.format('yyyy'))
                        const month = parseInt(value.format('MM'))
                        const min = new Date(`${year}-${month}-01`)
                        const max = new Date(`${year}-${month+1}-01`)

                        setSelect({
                            min: min.getTime(),
                            max: max.getTime(),
                        })
                    }
                }

                setDialogData(data)
            }}/>
        </React.Fragment>
    )
}

export default withNamespaces()(withRouter(Handicap))
